module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("UNITE and Conquer")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("• • •")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("How to Build Coalitions That Win—and Last")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("Kyrsten Sinema")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/0003.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Berrett—Koehler Publishers, Inc."), _c('br'), _vm._v("San Francisco a BK Currents book")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711c7672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 60
// module chunks = 0